import { MutationTree } from 'vuex';

import { TrabalhoSituacaoFinalModel } from '@/services/academico/situacaofinal/situacao-final.service';
import { AcompanhamentoAtaMutationTypes } from './mutation-types';
import { apagarPersistido, gravarPersistido, State } from './state';

/** O que a tela da ata entrega quando dispara um cálculo. */
export type TrabalhoAcompanhado = {
  idTrabalho: string;
  filtrosRelatorio: string | null;
  codigoRelatorio: string;
  codigoEscola: number;
  ano: number;
  semestre: number;
  titulo: string;
};

export type Mutations<S = State> = {
  [AcompanhamentoAtaMutationTypes.SET_TRABALHO](state: S, trabalho: TrabalhoAcompanhado): void;
  [AcompanhamentoAtaMutationTypes.SET_ANDAMENTO](
    state: S,
    trabalho: TrabalhoSituacaoFinalModel,
  ): void;
  [AcompanhamentoAtaMutationTypes.SET_ERRO](state: S, erro: string): void;
  [AcompanhamentoAtaMutationTypes.MOSTRAR](state: S): void;
  [AcompanhamentoAtaMutationTypes.OCULTAR](state: S): void;
  [AcompanhamentoAtaMutationTypes.ALTERNAR_RECOLHIDA](state: S): void;
  [AcompanhamentoAtaMutationTypes.LIMPAR](state: S): void;
};

/**
 * Grava no localStorage o que precisa sobreviver ao F5.
 *
 * Toda mutação que muda esses campos passa por aqui — deixar a gravação para o componente faria a
 * persistência depender de quem está montado, e a caixa pode nem estar visível.
 */
function persistir(state: State): void {
  if (!state.idTrabalho) {
    apagarPersistido();

    return;
  }

  gravarPersistido({
    idTrabalho: state.idTrabalho,
    filtrosRelatorio: state.filtrosRelatorio,
    codigoRelatorio: state.codigoRelatorio,
    codigoEscola: state.codigoEscola,
    ano: state.ano,
    semestre: state.semestre,
    titulo: state.titulo,
    visivel: state.visivel,
  });
}

export const mutations: MutationTree<State> & Mutations = {
  [AcompanhamentoAtaMutationTypes.SET_TRABALHO](state: State, trabalho: TrabalhoAcompanhado) {
    state.idTrabalho = trabalho.idTrabalho;
    state.filtrosRelatorio = trabalho.filtrosRelatorio;
    state.codigoRelatorio = trabalho.codigoRelatorio;
    state.codigoEscola = trabalho.codigoEscola;
    state.ano = trabalho.ano;
    state.semestre = trabalho.semestre;
    state.titulo = trabalho.titulo;
    state.trabalho = null;
    state.erro = '';
    state.visivel = true;
    state.recolhida = false;

    persistir(state);
  },
  [AcompanhamentoAtaMutationTypes.SET_ANDAMENTO](
    state: State,
    trabalho: TrabalhoSituacaoFinalModel,
  ) {
    state.trabalho = trabalho;
    state.erro = '';
  },
  [AcompanhamentoAtaMutationTypes.SET_ERRO](state: State, erro: string) {
    state.erro = erro;
  },
  [AcompanhamentoAtaMutationTypes.MOSTRAR](state: State) {
    state.visivel = true;
    state.recolhida = false;

    persistir(state);
  },
  [AcompanhamentoAtaMutationTypes.OCULTAR](state: State) {
    state.visivel = false;

    persistir(state);
  },
  [AcompanhamentoAtaMutationTypes.ALTERNAR_RECOLHIDA](state: State) {
    state.recolhida = !state.recolhida;
  },
  [AcompanhamentoAtaMutationTypes.LIMPAR](state: State) {
    state.idTrabalho = null;
    state.trabalho = null;
    state.filtrosRelatorio = null;
    state.codigoRelatorio = '';
    state.codigoEscola = 0;
    state.ano = 0;
    state.semestre = 0;
    state.visivel = false;
    state.recolhida = false;
    state.erro = '';

    apagarPersistido();
  },
};
